import { render, staticRenderFns } from "./LoginPopover.vue?vue&type=template&id=36c7b691"
import script from "./LoginPopover.vue?vue&type=script&lang=js"
export * from "./LoginPopover.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports